const prefix = `anyx|`;

export const FILTER_STORAGE_KEY = `${prefix}filters`;
export const OAUTH_STATE_STORAGE_KEY = `${prefix}oauth|state`;
export const REPORT_CALENDAR_STORAGE_KEY = `${prefix}report|calendar`;
export const INTERNAL_ADS_RECONNECT_STORAGE_KEY = `${prefix}internal-ads|reconnect-datasource-id`;
export const REPORT_DEFAULT_ACCOUNT_STORAGE_KEY = `${prefix}report|default-account`;
export const REPORT_DEFAULT_ACCOUNTS_STORAGE_KEY = `${prefix}report|default-accounts`;
export const SETTING_GUIDE_STORAGE_KEY = `${prefix}report|setting-guide`;
export const RECOMMEND_TIMEZONE_STORAGE_KEY = `${prefix}timezone|dismiss-recommend`;
